import { FilterOptionType, FilterTypeOperator } from '@monetize/types/common';
import {
  HIDE_TEST_ACCOUNT_FALSE_VALUE,
  HIDE_TEST_ACCOUNT_TRUE_VALUE,
  TEST_ACCOUNT_FILTER_KEY,
} from '../../../../constants/testAccountFilter.constants';
import { ToggleFilterOptionContent } from './ToggleFilterOptionContent';

export { TEST_ACCOUNT_FILTER_KEY };

/**
 * Builds the "Hide Test Account" toggle filter option for an `MDataTableFilter`
 * popover. Enabled by default (see `getDefaultFilter`); when on, it sends
 * `isTestAccount=false` so records belonging to a test account are hidden.
 *
 * @param label - Toggle label shown in the popover (e.g. "Hide Test Account Invoices")
 * @param key - Filter key; defaults to the shared `isTestAccount` key
 */
export const buildHideTestAccountFilterOption = (
  label = 'Hide Test Account',
  key: string = TEST_ACCOUNT_FILTER_KEY,
): FilterOptionType => ({
  title: '',
  key,
  operator: FilterTypeOperator.TOGGLE,
  renderOptionContent: (props) => (
    <ToggleFilterOptionContent {...props} label={label} />
  ),
  options: {
    falseValue: HIDE_TEST_ACCOUNT_FALSE_VALUE,
    trueValue: HIDE_TEST_ACCOUNT_TRUE_VALUE,
  },
});
